@switch (widgetConfig?.widgetType) {
    @case (TailoredWidgetType.BUSINESS_INTELLIGENCE_WIDGET) {
        <business-intelligence-widget-spawner
            class="height-100"
            [config]="widgetConfig?.businessIntelligenceConfiguration"
            [context]="context"
            [position]="position"
            (dataPointCount)="dataPointCount.emit($event)"
        />
    }
    @case (TailoredWidgetType.TEMPLATE_WIDGET) {
        <template-widget-spawner [config]="widgetConfig" />
    }
    @case (TailoredWidgetType.BASIC_WIDGET) {
        <basic-widget-spawner [config]="widgetConfig?.basicWidgetConfiguration" [context]="context" />
    }
    <!--To remove legacy widget spawner when the new architecture is ready-->
    @case (TailoredWidgetType.LEGACY_WIDGET) {
        <widget-spawner
            [widget]="widgetConfig?.legacyWidgetConfiguration?.legacyWidgetCode"
            [config]="widgetConfig?.legacyWidgetConfiguration?.legacyConfig"
        />
    }
}
